import { mobAlert } from "../mobx/MobAlert";
import i18n from "../i18n";

export const handleGraphQLError = (message, locations, path, extensions) => {
  switch (extensions?.exception?.error) {
    case "OUT_OF_RESERVATION":
      mobAlert.setError(i18n.t("generic.error"), i18n.t("pages.access.outsideBooking"));
      break;
    // Guestbook specific errors
    case "GUESTBOOK_ALREADY_DONE":
      mobAlert.setError(i18n.t("generic.error"), i18n.t("pages.explore.alreadyDone"));
      break;
    default:
      console.error(`[Erreur non gérée]: Message: ${message}, Localisation: ${locations}, Chemin: ${path}`);
      mobAlert.setError(i18n.t("errors.UNKNOWN_ERROR_TITLE"), i18n.t("errors.UNKNOWN_ERROR_TEXT", { errorCode: message }));
  }
};

